<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  نام فارسی دستگاه ها</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">نام دستگاه</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Devicepersian(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button routerLink="/DevicepersianAdd" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <button (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه دستگاه</th>
              <th>نام دستگاه</th>
              <th>نام فارسی</th>
              <th>کمیت</th>
              <th>زیر کمیت</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Devicepersian
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Devicepersian).length
                      }
            ">
             <td>{{DataList_Devicepersian.indexOf(item)+1}}</td>
              <td>{{item.device_id}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.quantity}}</td>
              <td>{{item.quantity_sub}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" [routerLink]="['/DevicepersianEdit',{id:item.id}]"><i class="fa fa-edit"></i> ویرایش </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4  class="modal-title pull-left">تایید حذف اطلاعات  تعرفه '{{Data_Seleted_Delete.device_name}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button   type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>



<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>نام دستگاه</th>
      <th>نام فارسی</th>
      <th>تاریخ</th>
      <th>کاربر</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Devicepersian">
      <td>{{DataList_Devicepersian.indexOf(item)+1}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.dsc}}</td>
      <td>{{item.persianDate}}</td>
      <td>{{item.username}} </td>
    </tr>
  </tbody>
</table>
